import React from 'react';
import { connect } from 'react-redux';

import '../../static/less/loyalty.less';

import PropTypes from 'prop-types';
import DsCoinBadge from '../ds/molecules/CoinBadge';
import { setShowLogin, setShowRegistration } from '../../actions/Loyalty';

class DSBannerBecomeLoyaltyMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLogin: false,
      showRegistration: false,
    };
  }

  asLoyaltyMemberInfoInBanner() {
    const { loyalty_main_url } = this.props.chainData.booking_engine_configuration;
    return (
      <div className={'text-base d-flex  md:w-4/6'}>
        <DsCoinBadge
          className='p-2'
          coins={this.props.coins}
          lang={this.props.lang}
          loyalty={this.props.loyalty}
          loggedUser={this.props.loggedUser}
          showURL={false}
        >
          {this.context.t('When checking out of the hotel, {chain} coins will be added to the account of the {chain} Member who made the reservation. The amount will be based on the percentage corresponding to their membership level, calculated on the amount of the stay (without tax).', {
            chain: this.props.chainData.loyalty_name.toUpperCase(),
          })}
        </DsCoinBadge>
        <div className={'mt-1 p-2'}>
          <p className={'mb-5'}>{
            this.context.t('As a {chain} member you can get discounts and benefits in exchange of coins', {
              chain: this.props.chainData.loyalty_name.toUpperCase(),
            })}.
          </p>
          <p>
            {this.context.t('Visit ')}
            <a className={'text-primary'} href={loyalty_main_url}>{loyalty_main_url}</a>
            {this.context.t(' to see all benefits')}.
          </p>
        </div>
      </div>
    );
  }

  becomeMemberInBanner() {
    return (
      <div className='px-1 text-justify'>
        <div className={'d-flex align-items-center flex-col lg:flex-row'}>
          <button
            className={'blue-style w-100 d-flex justify-center'}
            onClick={() => {
              this.props.dispatch(setShowRegistration(true));
            }}
          >
            {this.context.t('Become a member')}
          </button>
          {this.context.t('or')}
          <button
            className={'white-style w-100'}
            onClick={() => {
              this.props.dispatch(setShowLogin(true));
            }}
          >
            {this.context.t('Login')}
          </button>
        </div>
        <p className={'text-gray-500 text-sm font-medium'}>
          {this.context.t('*new members only')}
        </p>
      </div>
    );
  }

  render() {
    return (
      <div className={'shadow-card border-primary border-2 p-2 mb-5'}>
        <h2 className={'text-2xl text-primary-500 text-left uppercase font-bold'}>
          {this.props.chainData.loyalty_name.toUpperCase()}
        </h2>
        <div className={'content d-flex justify-between flex-wrap md:flex-nowrap'}>
          {this.asLoyaltyMemberInfoInBanner()}
          <div className={'becomeMemberInMyBooking'}>
            {this.becomeMemberInBanner()}
          </div>
        </div>
      </div>
    );
  }
}

DSBannerBecomeLoyaltyMember.propTypes = {
  chainData: PropTypes.object.isRequired,
  loyalty: PropTypes.object.isRequired,
  coins: PropTypes.number.isRequired,
  lang: PropTypes.string.isRequired,
};

DSBannerBecomeLoyaltyMember.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default connect(((state) => ({
  chainData: state.session.chainData,
  loggedUser: state.loyalty.loggedUser,
  hasRegistered: state.loyalty.hasRegistered,
  coinsForRegistering: state.loyalty.coinsForRegistering,
})))(DSBannerBecomeLoyaltyMember);
